/*
 *  Read More
 *    Script to add a class 'is-open' to a data-read-more container.
 *    Use CSS to style change your state changes.
 *
 *  Version:
 *    1.0.0 - 2023/07/14
 */

import $ from 'jquery';

//Selectors
export const READ_MORE_CONTAINER = '[data-read-more-container]';
export const READ_MORE_TOGGLE = '[data-read-more-toggle]';

//Classes
export const CLASS_CONTENT_OPEN = 'is-open';

export class ReadMore {
  constructor(container) {
    this.container = container;

    container.on('click touchstart', READ_MORE_TOGGLE, e => this.onReadMoreToggle(e));
  }

  onReadMoreToggle(e) {
    e.preventDefault(),e.stopPropagation();

    //Check state and add or remove class.
    this.container.toggleClass(CLASS_CONTENT_OPEN);
  }
}

$(() => $(READ_MORE_CONTAINER).each((i, e) => new ReadMore($(e))));